import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles/index';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import DeliveriesForStationsContainer from '../containers/logistics/StationDeliveriesForStation';
import EnhancedTableHead from '../components/EnhancedTableHead';
import { formatDeliveries } from '../libs/utility';
import ViewStationDeliveryDialog from './Dialogs/ViewStationDeliveryDialog';
import Transition from './Dialogs/Transition';
import AuthUserContainer from '../containers/AuthUser';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '90%',
		maxWidth: '90%',
	},
	row: {
		paddingBottom: 10,
	},
	label: {
		marginRight: 10,
	},
	value: {
		fontWeight: 600,
	},
	new: {
		marginTop: 20,
	},
	sectionHeader: {
		margin: '30px 0px 10px 0px',
		textAlign: 'left',
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
	},
	tankDivider: {
		paddingLeft: 5,
		paddingRight: 5,
		color: '#999',
	},
});

const columnStyle = { whiteSpace: 'nowrap' };
const columnData = [
	{
		id: 'stationDeliveryId',
		label: 'Delivery ID',
		padding: 'checkbox',
		style: { columnStyle },
	},
	{
		id: 'stationSort',
		numeric: false,
		padding: 'checkbox',
		label: 'Station(s)',
	},
	{
		id: 'dateSort',
		numeric: false,
		padding: 'checkbox',
		label: 'Delivery Window',
	},
	{
		id: 'primaryDeliveryAmount',
		numeric: true,
		padding: 'checkbox',
		label: 'Volume(s)',
	},
	{
		id: 'dateAndCarrier',
		numeric: false,
		padding: 'checkbox',
		label: 'Carrier',
	},
	{
		id: 'statusDisplay',
		numeric: false,
		padding: 'checkbox',
		label: 'Status',
	},
	{
		id: 'edit',
		numeric: false,
		padding: 'checkbox',
		label: 'Change',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class ViewStationDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newDgsValue: '',
			order: 'desc',
			orderBy: 'stationDeliveryId',
		};
	}

	componentDidUpdate(prevProps) {
		const {
			open,
			station,
			getStationDeliveriesForStation,
			stationDeliveriesForStation,
		} = this.props;

		if (open && prevProps.open !== open && !stationDeliveriesForStation) {
			getStationDeliveriesForStation({
				afterDateTime: moment().subtract(6, 'months').format('YYYY-MM-DD HH:mm:ss'),
				stationId: station.stationId,
			});
		}
	}

	handleClose = () => {
		this.props.onClose();
	};

	handleEdit = () => {
		this.props.history.push(`/station/update/${this.props.station.stationId}`);
	};

	render() {
		const {
			station,
			gasFormulaMap,
			rackFormulaMap,
			authUser,
			classes,
			stationDeliveriesForStation,
			stationMap,
			carrierMap,
			isExternalLogistics,
		} = this.props;

		const fields = [
			{ display: 'Station Number', key: 'number' },
			{ display: 'Station Name', key: 'name' },
			{ display: 'Contact Name', key: 'contactName' },
			{ display: 'Contact Phone Number', key: 'contactPhoneNumber' },
			{ display: 'Station Address', key: 'address' },
		];

		const freightFields = [
			{ display: 'Full load', key: 'freightFullLoad' },
			{ display: 'Half load with split', key: 'freightHalfLoadSplit' },
			{ display: 'Half load unable to split', key: 'freightHalfLoadNoSplit' },
		];

		const gasFormula = gasFormulaMap[station.gasFormulaId]
			? gasFormulaMap[station.gasFormulaId].display
			: 'Missing Pricing Formula';

		const rackFormula = rackFormulaMap[station.rackFormulaId]
			? rackFormulaMap[station.rackFormulaId].display
			: 'Missing Ethanol Cost Formula';

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		let deliveries = formatDeliveries({
			deliveries: stationDeliveriesForStation,
			isExternalLogistics,
			stationMap,
			carrierMap,
			handleRowClick: this.handleRowClick,
		});

		const action = isExternalLogistics ? 'View' : 'Edit';

		return (
			<Dialog
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<div className={classes.dialogPadding}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<DialogTitle>
								{station.number} - {station.name}
							</DialogTitle>
						</Grid>

						<Grid item xs={12} md={6}>
							<DialogActions>
								<Button onClick={this.handleClose}>Close</Button>
								{canMakeUpdates && (
									<Button variant="contained" onClick={this.handleEdit} color="primary">
										{action}
									</Button>
								)}
							</DialogActions>
						</Grid>
					</Grid>

					<DialogContent>
						{fields.map((field) => {
							return (
								<div key={field.key} className={classes.row}>
									<span className={classes.label}>{field.display}</span>
									<span className={classes.value}>{station[field.key]}</span>
								</div>
							);
						})}

						{!isExternalLogistics && (
							<>
								<div className={classes.sectionHeader}>Formulas</div>

								<div className={classes.row}>
									<span className={classes.label}>Pricing Formula</span>
									<span className={classes.value}>{gasFormula}</span>
								</div>

								<div className={classes.row}>
									<span className={classes.label}>Ethanol Cost Formula</span>
									<span className={classes.value}>{rackFormula}</span>
								</div>

								<div className={classes.sectionHeader}>Freights</div>
								{freightFields.map((field) => {
									return (
										<div key={field.key} className={classes.row}>
											<span className={classes.label}>{field.display}</span>
											<span className={classes.value}>{station[field.key]}</span>
										</div>
									);
								})}
							</>
						)}

						<div className={classes.sectionHeader}>Tanks</div>
						{station.tanks &&
							station.tanks.map((tank, i) => {
								return (
									<div key={i} className={classes.row}>
										<span className={classes.value}>{tank.productType}</span>
										<span className={classes.tankDivider}>/</span>

										<span className={classes.label}>Tank #</span>
										<span className={classes.value}>{tank.tankNumber}</span>

										<span className={classes.tankDivider}>/</span>
										<span className={classes.value}>{tank.totalTankVolume} gallons</span>

										<span className={classes.tankDivider}>/</span>
										<span className={classes.value}>{tank.tankType}</span>
									</div>
								);
							})}

						{!isExternalLogistics && (
							<>
								<div className={classes.sectionHeader}>Delivery Emails</div>
								{station.deliveryEmails &&
									station.deliveryEmails.map((email, i) => {
										return (
											<div key={i} className={classes.row}>
												<span className={classes.value}>{email}</span>
											</div>
										);
									})}
							</>
						)}

						{(!station.deliveryEmails || !station.deliveryEmails.length) && (
							<div>No delivery emails</div>
						)}

						<div className={classes.sectionHeader}>Delivery History</div>
						{!stationDeliveriesForStation && <div>Fetching delivery history...</div>}
						{stationDeliveriesForStation &&
							this.renderDeliveriesForStation({ deliveries, canMakeUpdates })}
					</DialogContent>
				</div>

				<ViewStationDeliveryDialog
					onClose={this.handleCloseViewDialog}
					stationDelivery={this.state.viewStationDelivery}
					stationMap={stationMap}
					authUser={authUser}
					open={this.state.isViewDialogOpen}
					history={this.props.history}
				/>
			</Dialog>
		);
	}

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleRowClick = (stationDeliveryId) => {
		const { stationDeliveriesForStation } = this.props;
		const viewStationDelivery = _.find(stationDeliveriesForStation, { stationDeliveryId });

		this.setState({
			viewStationDelivery,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewStationDelivery: undefined,
		});
	};

	renderDeliveriesForStation({ deliveries, canMakeUpdates }) {
		const { classes } = this.props;
		const { order, orderBy } = this.state;

		return (
			<Table size="small" style={{ width: 'auto', tableLayout: 'auto' }}>
				<EnhancedTableHead
					columnData={columnData}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleRequestSort}
				/>
				<TableBody>
					{deliveries.map((row) => {
						return (
							<TableRow hover className={classes.row} key={row.stationDeliveryId}>
								<TableCell>{row.stationDeliveryId}</TableCell>
								<TableCell onClick={row.rowClick}>{row.stations}</TableCell>
								<TableCell onClick={row.rowClick}>{row.dateTime}</TableCell>
								<TableCell onClick={row.rowClick} align="right">
									{row.volumes}
								</TableCell>
								<TableCell onClick={row.rowClick}>{row.carrierName}</TableCell>
								<TableCell onClick={row.rowClick} className={classes[row.statusClassName]}>
									{row.statusDisplay}
								</TableCell>

								{canMakeUpdates && (
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleEdit(row.stationDeliveryId)}
										>
											Change
										</Button>
									</TableCell>
								)}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		);
	}
}

ViewStationDialog.propTypes = {
	open: PropTypes.bool,
	station: PropTypes.object.isRequired,
	rackFormulaMap: PropTypes.object.isRequired,
	gasFormulaMap: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
	history: PropTypes.object,
	authUser: PropTypes.object,

	classes: PropTypes.object.isRequired,
	getStationDeliveriesForStation: PropTypes.func.isRequired,
	stationDeliveriesForStation: PropTypes.array,

	stationMap: PropTypes.object,
	carrierMap: PropTypes.object,
	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), DeliveriesForStationsContainer, AuthUserContainer])(
	ViewStationDialog
);
